import React from "react";
import styled from "styled-components";
import Col from "../../../../../../UIcomponent/Column";
import { devices } from "../../../../../../Utility/Devices";

const Container = styled.div`
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-evenly;
  order: 3;
  @media ${devices.laptop} {
    align-items: flex-end;
  }
  @media ${devices.tablet} {
    align-items: flex-start;
  }
  @media ${devices.mobileM} {
    font-size: 0.7rem;
  }
`;

function ClassInfo({ loading, data, classPosition }) {
  return (
    <Container>
      <div className="type">
        {data.LessonTitle === "Test" ? "آزمایشی" : data.LessonTitle}
      </div>
      <div className="detail">
        {` ${data.Session.Length} دقیقه`}
        {` / ${classPosition}`}
      </div>
    </Container>
  );
}

export default ClassInfo;
